interface RemovableTagUntaggedProps {
    onClick?: () => void;
}

export function RemovableTagUntagged({ onClick }: RemovableTagUntaggedProps) {
    return (
        <button
            className="h-8 px-4 border border-md-outline-variant bg-black text-white italic text-md-on-surface-variant rounded-full flex flex-row items-center"
            onClick={onClick}
        >
            <span className="font-normal italic">untagged</span>
        </button>
    );
}
